export interface ExpertCalibration_Interface {
  id:number,
  id_temp:number,
  name:string,
  familly:string,
  melicode:number,
  area_type:number,
  area_title:string,
  shomareh_Hamreh:string,
  name_Pedar:string,
  response:string,
  tarikh_Tavalod:string,
  dsc:string,
  persianDate:string,
  ip:string,
  creater:string,
  DeletingProccess:boolean,
  person_id:number,
  del:boolean,
  sms:boolean,
  visible:boolean,
  seleted:boolean,
}

export function Empty_ExpertCalibration_Interface():ExpertCalibration_Interface{
  return{
    id:0,
    id_temp:0,
    name:'',
    familly:'',
    melicode:0,
    area_type:0,
    area_title:'',
    tarikh_Tavalod:'',
    shomareh_Hamreh:'',
    name_Pedar:'',
    response:'',
    dsc:'',
    persianDate:'',
    ip:'',
    creater:'',
    DeletingProccess:false,
    sms:false,
    person_id:0,
    del:false,
    visible:false,
    seleted:false,
  }
}
